export const TRANSFORM_CONTROLS_OVERLAY_RENDER_ORDER = 10000;

function forEachMaterial(material, callback) {
  if (!material) return;

  if (Array.isArray(material)) {
    material.forEach((childMaterial) => forEachMaterial(childMaterial, callback));
    return;
  }

  callback(material);
}

function applyOverlayRendering(object) {
  if (!object) return;

  object.renderOrder = Math.max(object.renderOrder || 0, TRANSFORM_CONTROLS_OVERLAY_RENDER_ORDER);

  forEachMaterial(object.material, (material) => {
    material.depthTest = false;
    material.depthWrite = false;
    material.needsUpdate = true;
  });
}

export function keepTransformControlsVisible(control) {
  if (!control) return control;

  applyOverlayRendering(control);

  if (typeof control.traverse === "function") {
    control.traverse(applyOverlayRendering);
  }

  return control;
}
